// Auto generated file, do not manually modify!
// com.hotpads.leasing.model.enums.GeneratedLeaseDeclineReason

export enum GeneratedLeaseDeclineReason {
  ALREADY_SIGNED = 'ALREADY_SIGNED',
  DIDNT_UNDERSTAND = 'DIDNT_UNDERSTAND',
  NEED_MORE_TIME = 'NEED_MORE_TIME',
  NOT_READY_TO_SIGN = 'NOT_READY_TO_SIGN',
  OTHER = 'OTHER',
  USE_MY_OWN_LEASE = 'USE_MY_OWN_LEASE',
}

export const GeneratedLeaseDeclineReason_values = [
  GeneratedLeaseDeclineReason.ALREADY_SIGNED,
  GeneratedLeaseDeclineReason.DIDNT_UNDERSTAND,
  GeneratedLeaseDeclineReason.NEED_MORE_TIME,
  GeneratedLeaseDeclineReason.NOT_READY_TO_SIGN,
  GeneratedLeaseDeclineReason.OTHER,
  GeneratedLeaseDeclineReason.USE_MY_OWN_LEASE,
] as const;
